<div class="report_cls">
  <div class="report-title">
    DL离职问卷调查后台报表
  </div>
  <div class="select_cls">
    <label>请选择日期范围：</label>
    <nz-range-picker [(ngModel)]="selectConfig.insertDate" [nzAllowClear]="false"></nz-range-picker>
    <label style="margin-left: 20px;">隐藏重复记录：</label>
    <nz-radio-group [(ngModel)]="selectConfig.isHidden">
      <label nz-radio nzValue="Y">是</label>
      <label nz-radio nzValue="N">否</label>
    </nz-radio-group>
    <button nz-button nzType="primary" [nzSize]="size" (click)="getDownloadData()" class="search_btn">查询</button>
    <button nz-button nzType="primary" [nzSize]="size" (click)="clearQuery()" class="clear_btn">恢复默认</button>
  </div>
  <div class="download_btn">
    <button nz-button nzType="primary" [nzSize]="size" (click)="downData()" [disabled]="showTableData.length === 0" [nzLoading]="downloadLoading">下载excel</button>
  </div>
  <div class="tableContent">
    <nz-table #salaryCardTable [nzData]="showTableData" nzShowPagination nzBordered="true" [nzLoading]="searchLoading"
        [nzTotal]="showTableData.length" [nzShowTotal]="totalTemplate"
        [nzScroll]="{ x: '1150px' }" >
      <thead>
        <tr>
          <th [nzWidth]="'70px'" nzLeft>序号</th>
          <th [nzWidth]="'70px'" nzLeft>Site</th>
          <th [nzWidth]="'110px'" nzLeft>工号</th>
          <th [nzWidth]="'90px'" nzLeft>姓名</th>
          <th [nzWidth]="'90px'" nzLeft>部门</th>
          <th [nzWidth]="'170px'" nzLeft>身份证号</th>
          <th [nzWidth]="'120px'" nzLeft>手机号码</th>
          <th [nzWidth]="'100px'" nzLeft>申请类别</th>
          <th [nzWidth]="'120px'">期望离职日期</th>
          <th [nzWidth]="'160px'">离职原因类别</th>
          <th [nzWidth]="'250px'">离职原因</th>
          <th [nzWidth]="'180px'">留任机会点</th>
          <th [nzWidth]="'180px'">是否被访谈留任过</th>
          <th [nzWidth]="'180px'">访谈人员工号</th>
          <th [nzWidth]="'180px'">访谈人员姓名</th>
          <th [nzWidth]="'170px'">申请时间</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of salaryCardTable.data;let i=index">
          <td nzLeft>{{i + 1}}</td>
          <td nzLeft>{{item.site}}</td>
          <td nzLeft>{{item.emplid}}</td>
          <td nzLeft>{{item.cname}}</td>
          <td nzLeft>{{item.empDept}}</td>
          <td nzLeft>{{item.idcard}}</td>
          <td nzLeft>{{item.phonenum}}</td>
          <td nzLeft>{{item.empRequire}}</td>
          <td>{{item.hopeQuitdate}}</td>
          <td>{{item.reasonType}}</td>
          <td>{{item.quitReason}}</td>
          <td>{{item.comment}}</td>
          <td>{{item.isInterviewed}}</td>
          <td>{{item.talkerId}}</td>
          <td>{{item.talkerName}}</td>
          <td>{{item.insertDate}}</td>
        </tr>
      </tbody>
    </nz-table>
  <ng-template #totalTemplate let-total>总共{{total}}条数据</ng-template>
  </div>
</div>
